import { type ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import {
  FOCAL_TILE_CLASSNAME,
  QUICK_ACCESS_GRID_CLASSNAME,
  TILE_HEIGHT_PX,
  TILE_RADIUS,
} from './quick-access.constants.ts'

/**
 * Stands in for the full tile set — two focal tiles and four others, the two complete rows of the design.
 * The real grid drops a tile the customer's contracts rule out, which no placeholder can know ahead of the
 * data, so this is the shape it holds until then rather than a guess at the customer's own.
 */
export function QuickAccessSkeleton(): ReactElement {
  return (
    <div className={QUICK_ACCESS_GRID_CLASSNAME}>
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} className={FOCAL_TILE_CLASSNAME} />
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} className={FOCAL_TILE_CLASSNAME} />
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} />
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} />
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} />
      <Skeleton variant="block" height={TILE_HEIGHT_PX} radius={TILE_RADIUS} />
    </div>
  )
}
